<template>
  <!-- 210304 | id 추가 -->
  <section
    id="faq"
    class="faq"
  >
    <h2 class="title">
      자주하는 질문
    </h2>
    <VueFaqAccordion
      :items="faq"
    />
  </section>
</template>

<script>
import axios from 'axios'
import VueFaqAccordion from 'vue-faq-accordion'
export default {
  name: 'Faq',
  components:{
    VueFaqAccordion
  },
  data() {
    return {
      faq: [],
		}
  },
  created() {
    this.getData()
	},
  methods: {
    openModal(target) {
      this.$store.commit('modalOpen', target)
    },
    getData() {
			axios.get(`${process.env.BASE_URL}data/faq.json`)
				.then(response => {
					this.faq = response.data
				})
				.catch(error => {
					this.$eventHub.$emit('showError', error)
				})
				.then(() => {
				})
    },
    open(index) {ndex
      this.faq.forEach(item => {
        item.active = false
      })
      this.faq[index].active =! this.faq[index].active
    }
  }
}
</script>

<style lang="scss" scoped>
.faq{
  $self:&;
  width:1000px;
  height:auto;
  margin:0 auto;
  padding:100px 0 110px 0;
  position: relative;
  &:after{
    content:'';
    clear:both;
    display:block;
  }  
  &__row{
    padding-top:51px;
    &:after{
      content:'';
      clear:both;
      display:block;
    }  
    &:not(:last-child){
      padding-top:40px;
    }
  }
  &__buttons{
    padding-top:30px;
    &:after{
      clear:both;
      content:'';
      display:block;
    }
  }
  &__buttonitem{
    width:136px;
    height: 40px;
    float:left;
    &:not(:first-child){
      margin-left:10px;
    }
  }
}
</style>
